import * as React from "react";

import { CodeEditor } from "~/components/editor";

function TestEditor(props:any) {
    return (
        <div>
            <CodeEditor language={props.match.params.language} />
        </div>
    )
}

export default TestEditor;


// WEBPACK FOOTER //
// ./src/containers/TestEditor.tsx